export const selectUser = (state) => state.user.user;

export const selectIsUserModalOpen = (state) => state.user.isUserModalOpen;

export const selectIsEditModalOpen = (state) => state.user.isEditModalOpen;
